(() => {
  const picker = document.querySelector('[data-preorder-bundle-picker]');
  if (!picker) return;

  const bundleTotalCents = parseInt(picker.dataset.bundleTotalCents, 10);
  const containerVariantId = picker.dataset.containerVariantId;

  const lockedRow = picker.querySelector('.preorder-bundle-picker__row--locked');
  const lockedCapCents = parseInt(lockedRow.dataset.capCents, 10) || 0;
  const lockedTitle = lockedRow.dataset.productTitle;

  const dropdowns = Array.from(picker.querySelectorAll('[data-bundle-dropdown]'));
  const cta = picker.querySelector('[data-bundle-cta]');
  const hint = picker.querySelector('[data-bundle-hint]');
  const retailEl = picker.querySelector('[data-bundle-retail]');
  const saveWrap = picker.querySelector('[data-bundle-save-wrap]');
  const saveAmountEl = picker.querySelector('[data-bundle-save-amount]');
  const savePercentEl = picker.querySelector('[data-bundle-save-percent]');

  const formatMoney = (cents) => {
    const value = (cents / 100).toFixed(2);
    return `£${value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
  };

  const getSelectedOption = (dd) => {
    const v = dd.dataset.value;
    if (!v) return null;
    return Array.from(dd.querySelectorAll('[data-bundle-option]')).find((o) => o.dataset.value === v) || null;
  };

  const buildPlaceholderNode = (text) => {
    const span = document.createElement('span');
    span.className = 'preorder-bundle-picker__trigger-placeholder';
    span.textContent = text;
    return span;
  };

  const buildSelectedNode = (imgUrl, title) => {
    const frag = document.createDocumentFragment();
    if (imgUrl) {
      const img = document.createElement('img');
      img.className = 'preorder-bundle-picker__trigger-img';
      img.src = imgUrl;
      img.alt = '';
      img.loading = 'lazy';
      img.width = 40;
      img.height = 40;
      frag.appendChild(img);
    } else {
      const ph = document.createElement('span');
      ph.className = 'preorder-bundle-picker__trigger-img preorder-bundle-picker__trigger-img--placeholder';
      ph.setAttribute('aria-hidden', 'true');
      frag.appendChild(ph);
    }
    const titleEl = document.createElement('span');
    titleEl.className = 'preorder-bundle-picker__trigger-title';
    titleEl.textContent = title;
    frag.appendChild(titleEl);
    return frag;
  };

  const updateTriggerUI = (dd) => {
    const trigger = dd.querySelector('[data-dropdown-trigger]');
    const content = trigger.querySelector('[data-trigger-content]');
    while (content.firstChild) content.removeChild(content.firstChild);

    const opt = getSelectedOption(dd);
    if (!opt) {
      content.appendChild(buildPlaceholderNode(trigger.dataset.placeholder || ''));
      return;
    }
    content.appendChild(buildSelectedNode(opt.dataset.productImage || '', opt.dataset.productTitle || ''));
  };

  const closeAllDropdowns = (except) => {
    dropdowns.forEach((dd) => {
      if (dd === except) return;
      const trigger = dd.querySelector('[data-dropdown-trigger]');
      const panel = dd.querySelector('[data-dropdown-options]');
      trigger.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
    });
  };

  const render = () => {
    const selectedValues = [];
    const titles = [lockedTitle];
    let totalCapCents = lockedCapCents;

    dropdowns.forEach((dd) => {
      const opt = getSelectedOption(dd);
      const row = dd.closest('.preorder-bundle-picker__row');
      const priceEl = row.querySelector('[data-row-price]');
      const selectedClass = 'preorder-bundle-picker__row--selected';

      if (opt) {
        selectedValues.push(opt.dataset.value);
        const cap = parseInt(opt.dataset.capCents, 10) || 0;
        totalCapCents += cap;
        titles.push(opt.dataset.productTitle);
        priceEl.textContent = formatMoney(cap);
        row.classList.add(selectedClass);
      } else {
        priceEl.textContent = '—';
        row.classList.remove(selectedClass);
      }
    });

    const allFilled = selectedValues.length === dropdowns.length;

    if (!allFilled) {
      hint.textContent = `Pick ${dropdowns.length - selectedValues.length} more to complete your bundle`;
      retailEl.textContent = '';
      saveWrap.hidden = true;
      cta.disabled = true;
      cta.dataset.bundleTitles = '';
      return;
    }

    const saveCents = Math.max(totalCapCents - bundleTotalCents, 0);
    const savePercent = totalCapCents > 0 ? Math.round((saveCents * 100) / totalCapCents) : 0;
    const hasSavings = saveCents > 0;

    hint.textContent = 'Bundle ready';
    retailEl.textContent = hasSavings ? formatMoney(totalCapCents) : '';
    saveAmountEl.textContent = formatMoney(saveCents);
    savePercentEl.textContent = `${savePercent}% OFF`;
    saveWrap.hidden = !hasSavings;
    cta.disabled = false;
    cta.dataset.bundleTitles = JSON.stringify(titles);
  };

  dropdowns.forEach((dd) => {
    const trigger = dd.querySelector('[data-dropdown-trigger]');
    const panel = dd.querySelector('[data-dropdown-options]');

    trigger.addEventListener('click', () => {
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      closeAllDropdowns(dd);
      trigger.setAttribute('aria-expanded', String(!isOpen));
      panel.hidden = isOpen;
      if (!isOpen) {
        const selected = panel.querySelector('[data-bundle-option][aria-selected="true"]');
        const fallback = panel.querySelector('[data-bundle-option]');
        (selected || fallback)?.focus({ preventScroll: true });
      }
    });

    dd.querySelectorAll('[data-bundle-option]').forEach((opt) => {
      opt.addEventListener('click', () => {
        dd.dataset.value = opt.dataset.value;
        dd.querySelectorAll('[data-bundle-option]').forEach((o) => o.setAttribute('aria-selected', 'false'));
        opt.setAttribute('aria-selected', 'true');
        updateTriggerUI(dd);
        trigger.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
        trigger.focus({ preventScroll: true });
        render();
      });
    });
  });

  document.addEventListener('click', (e) => {
    if (!picker.contains(e.target)) closeAllDropdowns();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAllDropdowns();
  });

  cta.addEventListener('click', async () => {
    if (cta.disabled) return;
    const titles = JSON.parse(cta.dataset.bundleTitles || '[]');
    if (titles.length !== 4) return;

    const properties = {};
    titles.forEach((t, i) => {
      properties[`Product ${i + 1}`] = t;
    });

    const originalLabel = cta.textContent;
    cta.disabled = true;
    cta.textContent = 'Adding…';

    const cartDrawer = document.querySelector('cart-drawer');
    const sectionsToRender = cartDrawer
      ? cartDrawer.getSectionsToRender().map((s) => s.id)
      : [];

    try {
      const res = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: containerVariantId, quantity: 1, properties }],
          sections: sectionsToRender,
          sections_url: window.location.pathname,
        }),
      });

      const data = await res.json();

      if (!res.ok || data.status) {
        throw new Error(data.description || data.message || 'Could not add bundle to cart');
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'preorder-bundle-picker',
          productVariantId: containerVariantId,
          cartData: data,
        });
      }

      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data);
        if (cartDrawer.classList.contains('is-empty')) {
          cartDrawer.classList.remove('is-empty');
        }
        cartDrawer.open();
      }

      cta.disabled = false;
      cta.textContent = originalLabel;
      hint.textContent = 'Bundle ready';
    } catch (err) {
      console.error('[preorder-bundle-picker]', err);
      cta.disabled = false;
      cta.textContent = originalLabel;
      hint.textContent = err.message || 'Something went wrong. Please try again.';
    }
  });

  render();
})();
